import { Factory, trait } from 'miragejs';

export default Factory.extend({
  rules() {
    // default to open 24/7
    return ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'].map((day) => ({
      enabled: true,
      'recurring-rule': `FREQ=WEEKLY;BYDAY=${day}`,
      intervals: [{ from: '00:00', to: '00:00' }],
    }));
  },

  // explicit trait for 24/7 rules
  'as24/7': trait({
    rules() {
      return ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'].map((day) => ({
        enabled: true,
        'recurring-rule': `FREQ=WEEKLY;BYDAY=${day}`,
        intervals: [{ from: '00:00', to: '00:00' }],
      }));
    },
  }),

  as9to5: trait({
    rules() {
      return [
        ...['MO', 'TU', 'WE', 'TH', 'FR'].map((day) => ({
          enabled: true,
          'recurring-rule': `FREQ=WEEKLY;BYDAY=${day}`,
          intervals: [{ from: '09:00', to: '17:00' }],
        })),
        { enabled: false, 'recurring-rule': 'FREQ=WEEKLY;BYDAY=SA', intervals: [{ from: '00:00', to: '00:00' }] },
        { enabled: false, 'recurring-rule': 'FREQ=WEEKLY;BYDAY=SU', intervals: [{ from: '00:00', to: '00:00' }] },
      ];
    },
  }),
});
